import React from 'react';
import PropTypes from 'prop-types';
import { OuterDonut, ValueSkeleton, ValueWrapper, Wrapper } from './styles';
export function DonutChartSkeleton(_ref) {
  var size = _ref.size,
      thickness = _ref.thickness,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(Wrapper, {
    size: size,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(OuterDonut, {
    variant: 'default',
    size: size,
    thickness: thickness,
    value: 100
  }), /*#__PURE__*/React.createElement(ValueWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(ValueSkeleton, {
    size: size,
    height: Math.round(size / 4),
    width: Math.round(size / 2)
  })));
}
DonutChartSkeleton.propTypes = {
  thickness: PropTypes.number,
  size: PropTypes.number
};
export default DonutChartSkeleton;